import { render, staticRenderFns } from "./comment-editor.vue?vue&type=template&id=300ad1f6&"
import script from "./comment-editor.vue?vue&type=script&lang=ts&"
export * from "./comment-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports